import { useEffect, useState } from "react"
import Sidebar from "./Sidebar"
import Navbar from "./Navbar"
import { fr } from "../../locales/fr"

const DESKTOP_SIDEBAR_KEY = "gymflow-sidebar-desktop-expanded"

function readDesktopSidebarExpanded() {
  try {
    const v = localStorage.getItem(DESKTOP_SIDEBAR_KEY)
    if (v === null) return true
    return v === "true"
  } catch {
    return true
  }
}

export default function DashboardLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(readDesktopSidebarExpanded)

  const closeSidebar = () => setSidebarOpen(false)

  useEffect(() => {
    try {
      localStorage.setItem(DESKTOP_SIDEBAR_KEY, String(desktopSidebarOpen))
    } catch {
      /* ignore */
    }
  }, [desktopSidebarOpen])

  const toggleMenu = () => {
    const isLg =
      typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
    if (isLg) setDesktopSidebarOpen((o) => !o)
    else setSidebarOpen((o) => !o)
  }

  const collapseDesktopSidebar = () => setDesktopSidebarOpen(false)

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape") return
      if (sidebarOpen) {
        closeSidebar()
        return
      }
      const isLg =
        typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
      if (isLg && desktopSidebarOpen) setDesktopSidebarOpen(false)
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [sidebarOpen, desktopSidebarOpen])

  return (
    <div className="min-h-screen bg-background">
      {/*
        Voile mobile : commence sous le header (top-16) pour ne pas recouvrir le bouton menu.
        La sidebar en z-50 au-dessus du voile mais aussi sous le bandeau (même top-16), sinon
        le panneau masquait toute la barre et le burger n’était pas cliquable.
      */}
      {sidebarOpen && (
        <button
          type="button"
          aria-label={fr.navbar.closeMenu}
          className="fixed inset-x-0 bottom-0 top-16 z-40 bg-background/70 backdrop-blur-sm lg:hidden"
          onClick={closeSidebar}
        />
      )}

      {/*
        Panneau latéral : largeur explicite sur le wrapper (l’ancien aside en fixed sortait du flux,
        le parent avait 0×0 et le translate ne masquait pas le menu sur mobile).
        Sur mobile : top-16 pour laisser le header (burger) accessible.
      */}
      {/*
        Largeur desktop = lg:w-64 pour coller exactement à lg:pl-64 du contenu (sinon ~32px
        du titre passent sous la barre si la sidebar reste à 18rem).
        Mobile : panneau un peu plus large que la grille (min 18rem).
      */}
      <div
        className={`
          fixed left-0 z-50 flex w-[min(18rem,88vw)] max-w-[85vw] flex-col shadow-lg transition-transform duration-300 ease-in-out lg:w-64 lg:max-w-none
          max-lg:top-16 max-lg:bottom-0 lg:inset-y-0 lg:h-full
          ${sidebarOpen ? "max-lg:translate-x-0" : "max-lg:-translate-x-full max-lg:pointer-events-none"}
          ${desktopSidebarOpen ? "lg:translate-x-0" : "lg:-translate-x-full lg:pointer-events-none"}
          lg:shadow-none
        `}
      >
        <Sidebar onNavigate={closeSidebar} onCollapseDesktop={collapseDesktopSidebar} />
      </div>

      <div
        className={`
          min-w-0 transition-[padding] duration-300 ease-in-out
          ${desktopSidebarOpen ? "lg:pl-64" : "lg:pl-0"}
        `}
      >
        <Navbar onMenuClick={toggleMenu} showMenuOnDesktop={!desktopSidebarOpen} />
        <main className="min-h-[calc(100vh-4rem)] p-4 sm:p-6">
          {children}
        </main>
      </div>
    </div>
  )
}
